import type { PropsWithChildren } from 'react';

import type { PreferenceInput } from '../contract/wire';
import LocalizationProvider from '../react/LocalizationProvider';
import { TEST_PREFERENCES } from './preferences';

type LocalizationWrapperProps = {
  /** Stand in for a different user. Defaults to {@link TEST_PREFERENCES}. */
  preferences?: PreferenceInput;
  /** Mount with the rollout flag off, to assert what a surface degrades to. Defaults to on. */
  enabled?: boolean;
};

/**
 * Mounts the localization context without an app shell, so a component under test can be rendered
 * on its own.
 */
const LocalizationWrapper = ({
  preferences = TEST_PREFERENCES,
  enabled = true,
  children,
}: PropsWithChildren<LocalizationWrapperProps>): JSX.Element => (
  <LocalizationProvider preferences={preferences} enabled={enabled}>
    {children}
  </LocalizationProvider>
);

export default LocalizationWrapper;
